import { useTranslator } from '@translator-app/react';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';

import { ANDROID_APP_ID, IOS_APP_ID } from '../../constants';
import { useKioskMode } from '../../contexts/kiosk-context';
import { MobileOS, getMobileOS } from '../../utils/getMobileOS';

interface Props {
  url?: string;
}

export const AppBanner: React.FC<Props> = (props) => {
  const { url } = props;
  const { translate } = useTranslator();
  const [showAndroidPopup, setShowAndroidPopup] = useState(false);
  const { isKioskMode } = useKioskMode();

  const iosMetadataContent = [`app-id=${IOS_APP_ID}`];
  if (url) {
    iosMetadataContent.push(`app-argument=${url}`);
  }

  const androidUrl = `http://play.google.com/store/apps/details?id=${ANDROID_APP_ID}`;
  useEffect(() => {
    setShowAndroidPopup(getMobileOS() === MobileOS.Android && !isKioskMode);
  }, [isKioskMode]);

  return (
    <>
      <Head>
        <meta name="apple-itunes-app" content={iosMetadataContent.join(', ')} />
      </Head>

      {showAndroidPopup && (
        <a
          className="w-full bg-primary-light group p-4 px-8 flex flex-wrap justify-center items-center gap-y-2 gap-x-4"
          href={androidUrl}
        >
          <div className="font-medium">{translate('appBanner.downloadAppText')}</div>
          <div className="bg-primary text-white rounded px-4 py-2 font-medium group-hover:bg-primary-dark">
            {translate('appBanner.viewButton')}
          </div>
        </a>
      )}
    </>
  );
};
